export default __webpack_public_path__ + "static/media/plus-thin.e7a69968.svg";